/**
 * Central mapping "user role -> home path" so the login/invite/root redirects
 * stay consistent when new roles are added.
 */
export function homePathForRole(role) {
  if (role === "admin") return "/admin";
  if (role === "introducer") return "/introducer";
  return "/dashboard";
}
